import { render, staticRenderFns } from "./MetodePengirimanModal.vue?vue&type=template&id=770c5206&scoped=true&"
import script from "./MetodePengirimanModal.vue?vue&type=script&lang=js&"
export * from "./MetodePengirimanModal.vue?vue&type=script&lang=js&"
import style0 from "./MetodePengirimanModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MetodePengirimanModal.vue?vue&type=style&index=1&id=770c5206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c5206",
  null
  
)

export default component.exports